import { render, staticRenderFns } from "./HowItWorks.vue?vue&type=template&id=3f6fdb4c&scoped=true"
import script from "./HowItWorks.vue?vue&type=script&lang=ts"
export * from "./HowItWorks.vue?vue&type=script&lang=ts"
import style0 from "./HowItWorks.vue?vue&type=style&index=0&id=3f6fdb4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f6fdb4c",
  null
  
)

export default component.exports